import React from 'react';

import BrowseApiButton from 'pages/Landings/components/BrowseApiButton';
import GetStartedButton from 'pages/Landings/components/GetStartedButton';
import { BookIcon } from 'pages/Landings/components/Icons';
import TitleSection from 'pages/Landings/components/TitleSection';
import ProductsSection from 'pages/Landings/sections/Home/components/ProductsSection';

import useStyles from './styles';

import Layout from '../components/Layout';

const Docs: React.FC = () => {
    const { classes } = useStyles();
    return (
        <Layout>
            <TitleSection
                title="Documentation for the Vulners API"
                smaller
                description="This is the official documentation for Vulners API"
                breadcrumb="Documentation"
                buttons={
                    <>
                        <GetStartedButton />
                        <BrowseApiButton />
                    </>
                }
                illustration={<BookIcon />}
                className={classes.title}
            />
            <ProductsSection untitled className={classes.section} />
        </Layout>
    );
};

export default Docs;
